import { createBrowserRouter as createRRBrowserRouter, Outlet, RouteObject } from 'react-router-dom';

import ScrollToTop from './ScrollToTop';
import { QueryParamProvider } from './useQueryParams';

export function createBrowserRouter({
  protectedRoutes,
  publicRoutes,
}: {
  protectedRoutes: RouteObject[];
  publicRoutes: RouteObject[];
}) {
  return createRRBrowserRouter([
    {
      path: 'public/*',
      element: (
        <QueryParamProvider>
          <ScrollToTop />
          <Outlet />
        </QueryParamProvider>
      ),
      children: publicRoutes,
    },
    {
      path: '*',
      element: (
        <QueryParamProvider>
          <ScrollToTop />
          <Outlet />
        </QueryParamProvider>
      ),
      children: protectedRoutes,
    },
  ]);
}
